





































import Vue from "vue";
import VelloIcon from "@/components/vue-components/VelloIcon.vue";
import Controls from "@/components/vue-components/Controls.vue";
import ReviewForm from "@/components/review/ReviewForm.vue";
import { Fetch } from "@/plugins/fetch";
import { getTimestamp } from "@/common/common";

export default Vue.extend({
  name: "ReviewEntry",
  components: {
    VelloIcon,
    Controls,
    ReviewForm
  },
  props: {
    email: {
      type: String,
      default: null
    },
    expire: {
      type: String,
      default: null
    },
    hash: {
      type: String,
      default: null
    },
    token: {
      type: String,
      default: null
    },
    review_token: {
      type: String,
      default: null
    }
  },
  data: () => {
    return {
      status: "base" as string,
      baseUrl: process.env.VUE_APP_VELLO_URL as string,
      review_metadata: {
        customer: {},
        company: {},
        review_id: "",
        update_token: ""
      },
      score: 5 as number,
      error: "" as string
    };
  },
  computed: {
    getToken(): string {
      return this.$store.getters.GET_CSRF_INFORMATION.token;
    }
  },
  methods: {
    async submitReviewWithScoreOnly(): Promise<void> {
      try {
        try {
          this.score = parseInt(this.$route.query.score as string);
        } catch {
          // handle silently and fallback to 5
          this.score = 5;
        }

        const { email, token, expire, hash, review_token } = this.$props;
        const { review_metadata } = await Fetch.post(
          `review/?email=${email}&token=${token}&expire=${expire}&hash=${hash}&review_token=${review_token}`,
          this.getToken,
          {
            score: this.score
          }
        );
        this.review_metadata = review_metadata;
        this.status = "ready";
      } catch (e) {
        this.status = "ready";

        this.status = "error";
        this.error = "customer-dashboard.review-form.errors.unable-to-review";
      }
    }
  },

  async created() {
    if (
      !this.$props.email &&
      !this.$props.hash &&
      !this.$props.token &&
      !this.$props.expire &&
      !this.$props.review_token &&
      !this.$props.score
    ) {
      this.status = "error";
      this.error = "customer-dashboard.review-form.errors.unable-to-review";
      return;
    }

    if (this.$props.expire < getTimestamp()) {
      this.status = "error";
      this.error = "customer-dashboard.review-form.errors.unable-to-review";
      return;
    }

    this.status = "loading";

    await this.submitReviewWithScoreOnly();
  }
});
